// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityInfoActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withProps = require('recompose').withProps;
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var AccountUtils = require('modules/Account/Izenda.AccountUtils');
  var AuthorizationStore = require('logic/Izenda.AuthorizationStore');
  const { curry } = require('lodash/fp');

  var securityInfoActions = compose(
    withProps(function() {
      return {
        authorizationStore: new AuthorizationStore()
      };
    }),
    withHandlers({
      onChangePassword: curry(onChangePassword),
      onChangeConfirmPassword: curry(onChangeConfirmPassword),
      onChangeQuestion: curry(onChangeQuestion),
      onChangeAnswer: curry(onChangeAnswer),
      onClickBack: curry(onClickBack),
      onClickSubmit: curry(onClickSubmit)
    })
  );

  /**
   * Handle on change password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangePassword(props, value) {
    props.store.model.updateProperty('password', value);
  }

  /**
   * Handle on change confirm password.
   * @param  {Object} props
   * @param  {String} value
   */
  function onChangeConfirmPassword(props, value) {
    props.store.model.updateProperty('confirmPassword', value);
  }

  /**
   * Handle on change question.
   * @param  {Object} props
   * @param  {Object} question
   * @param  {String} value
   */
  function onChangeQuestion(props, question, value) {
    props.store.model.updateUserSecurityQuestion(question, 'securityQuestionId', value);
  }

  /**
   * Handle on change Answer.
   * @param  {Object} props
   * @param  {Object} question
   * @param  {String} value
   */
  function onChangeAnswer(props, question, value) {
    props.store.model.updateUserSecurityQuestion(question, 'answer', value);
  }

  /**
   * Handle on click back.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickBack(props, obj) {
    props.store.model.updateCurrentStep(AccountConstants.STEP_KEYS.AccountInfo);
  }

  /**
   * Handle on click submit.
   * @param  {Object} props
   * @param  {Object} obj
   */
  function onClickSubmit(props, obj) {
    var store = props.store;
    return props.validation.validate().then(function(result) {
      if (result) {
        var loader = props.loader;
        loader.startLoading();
        return store
          .passwordAndSecurityQuestion()
          .then(function(result) {
            if (result.success) {
              return props.confirmMessage('info', AccountConstants.MESSAGES.M02).then(function() {
                return AccountUtils.setUpAuthInfo(result, props);
              });
            }

            return store.loadGeneralErrorMessage(result.messages);
          })
          .finally(loader.endLoading.bind(loader));
      }
      return Promise.resolve(false);
    });
  }

  module.exports = securityInfoActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.SecurityInfoActions.js